import React from 'react';
import { FileText, ExternalLink } from 'lucide-react';
import type { SearchDocumentsWidgetData } from '../../../types/agentWidgets';
import { useDocumentViewer } from '../../../contexts/DocumentViewerContext';

interface Props {
  data: SearchDocumentsWidgetData;
}

export const SearchDocumentsWidget: React.FC<Props> = ({ data }) => {
  const { openDocument } = useDocumentViewer();

  if (data.sources.length === 0) return null;

  return (
    <div className="mt-1.5 space-y-1">
      <p className="text-[10px] uppercase tracking-wide text-gray-400 dark:text-gray-500 font-medium">
        {data.sources.length} source{data.sources.length !== 1 ? 's' : ''} found
      </p>
      <div className="space-y-1">
        {data.sources.map((src, i) => (
          <div
            key={i}
            className="flex items-center gap-2 text-[11px] bg-cyan-50/70 dark:bg-cyan-900/10 rounded px-2 py-1.5 group"
          >
            <FileText className="h-3 w-3 text-cyan-500 dark:text-cyan-400 flex-shrink-0" />
            <span className="font-medium text-cyan-700 dark:text-cyan-300 truncate flex-1 min-w-0">
              {src.documentName}
            </span>
            {src.pageNumber != null && (
              <span className="text-gray-400 dark:text-gray-500 whitespace-nowrap text-[10px]">
                p.{src.pageNumber}
              </span>
            )}
            {src.documentId && (
              <button
                onClick={() =>
                  openDocument({
                    documentId: src.documentId!,
                    documentName: src.documentName,
                    pageNumber: src.pageNumber,
                    searchText: src.excerpt || undefined,
                  })
                }
                className="text-cyan-600 dark:text-cyan-400 hover:underline whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity text-[10px] font-medium"
              >
                View
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
